import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditCatalogSections from './EditCatalogSections'
import ListCatalogSections from './ListCatalogSections'
import NewCatalogSections from './NewCatalogSections'

const AdminCatalogSectionsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCatalogSections /></PrivateRoute7>} />
        <Route path="edit-section" element={<PrivateRoute7><EditCatalogSections /></PrivateRoute7>} />
        <Route path="new-section" element={<PrivateRoute7><NewCatalogSections /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCatalogSectionsRoutes